export const NAME = 'redeems';